import { render, staticRenderFns } from "./showMail.vue?vue&type=template&id=19025e43"
import script from "./showMail.vue?vue&type=script&lang=js"
export * from "./showMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports